export default "__VITE_ASSET__BQCSHKzs__"